"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Header } from "@components/header";
import { Sidebar } from "@components/sidebar";
import { BreadcrumbNav } from "@components/nav-bar";
import { sidebarItems } from "@components/sidebar/data";
import { NavBarVisibilityProvider } from "@components/nav-bar/visibility";
import { NavBarActionsProvider } from "@components/nav-bar/actions";
import { DiningOrderAudioGestureUnlock } from "@components/dining/dining-order-audio-gesture-unlock";
import { ChatbotPanel } from "@components/chatbot/ChatbotPanel";
export const AppShell = t0 => {
  const $ = _c(20);
  const {
    children
  } = t0;
  const [navBarVisible, setNavBarVisible] = useState(true);
  const [navBarActions, setNavBarActions] = useState(null);
  let t1;
  if ($[0] !== navBarVisible) {
    t1 = {
      visible: navBarVisible,
      setVisible: setNavBarVisible
    };
    $[0] = navBarVisible;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== navBarActions) {
    t2 = {
      actions: navBarActions,
      setActions: setNavBarActions
    };
    $[2] = navBarActions;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DiningOrderAudioGestureUnlock />;
    t4 = <ChatbotPanel />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Header />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="h-[calc(100vh_-_var(--app-header-offset)_-_8px)] max-h-[calc(100vh_-_var(--app-header-offset)_-_8px)] shrink-0"><Sidebar /></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== navBarActions || $[9] !== navBarVisible) {
    t7 = navBarVisible && <div className="mt-2"><BreadcrumbNav items={sidebarItems} includeHome={true} isParent={true} rightSlot={navBarActions} /></div>;
    $[8] = navBarActions;
    $[9] = navBarVisible;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== children || $[12] !== t7) {
    t8 = <div className="flex h-full flex-col bg-background">{t5}<div className="mt-2 flex h-[calc(100vh_-_var(--app-header-offset)_-_8px)] min-h-0 gap-2 overflow-hidden bg-background">{t6}<main className="h-[calc(100vh_-_var(--app-header-offset)_-_8px)] max-h-[calc(100vh_-_var(--app-header-offset)_-_8px)] min-h-0 min-w-0 flex-1 overflow-y-auto bg-background pr-4 scrollbar-hide">{t7}{children}</main></div></div>;
    $[11] = children;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t2 || $[15] !== t8) {
    t9 = <NavBarActionsProvider value={t2}>{t3}{t4}{t8}</NavBarActionsProvider>;
    $[14] = t2;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t1 || $[18] !== t9) {
    t10 = <NavBarVisibilityProvider value={t1}>{t9}</NavBarVisibilityProvider>;
    $[17] = t1;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};